import React, { useEffect, useState } from "react";
import { Dialog } from "@material-tailwind/react";

export const Modal = ({ hideModal, onConfirm, onCancel = () => {}, children: createDialog, size='md' }) => {
  const [open, setOpen] = useState(false);
  const close = then => {
    setOpen(false);

    setTimeout(() => {
      hideModal();
      then && then();
    }, 500);
  }

  const handleCancel = () => {
    close(() => onCancel());
  };

  const handleConfirm = args => {
    close(() => onConfirm(args));
  };

  useEffect(() => setOpen(true), []);

  return (
    <Dialog open={open} className="py-[25px]" size={size}>
        {createDialog({
            handleConfirm,
            handleCancel
        })}
    </Dialog>
  );
}
